import React, { useState } from 'react';
import operatorService from '../../services/operatorService';

const DocumentUpload = ({ currentUser, onUploadComplete }) => {
  const [uploading, setUploading] = useState(false);
  const [dragActive, setDragActive] = useState(false);

  const handleDrag = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === "dragenter" || e.type === "dragover") {
      setDragActive(true);
    } else if (e.type === "dragleave") {
      setDragActive(false);
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);

    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      handleFileUpload(e.dataTransfer.files[0]);
    }
  };

  const handleChange = (e) => {
    e.preventDefault();
    if (e.target.files && e.target.files[0]) {
      handleFileUpload(e.target.files[0]);
    }
  };

  const handleFileUpload = async (file) => {
    if (!currentUser) {
      alert('Please log in to upload documents');
      return;
    }

    // Validate file type
    const allowedTypes = ['application/pdf', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'text/plain'];
    if (!allowedTypes.includes(file.type)) {
      alert('Unsupported file type. Please upload PDF, DOCX, or TXT files.');
      return;
    }

    // Validate file size (50MB)
    if (file.size > 50 * 1024 * 1024) {
      alert('File too large. Maximum size is 50MB.');
      return;
    }

    setUploading(true);

    try {
      const formData = new FormData();
      formData.append('document', file);
      formData.append('user_id', currentUser.id || 'demo-user');
      formData.append('company_id', currentUser.company_id || 'demo-company');
      formData.append('tags', '');

      const result = await operatorService.uploadDocument(formData);

      if (result.success) {
        alert('Document uploaded successfully!');
        if (onUploadComplete) {
          onUploadComplete();
        }
      }
    } catch (error) {
      console.error('Upload failed:', error);
      alert('Failed to upload document. Please try again.');
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="document-upload-container">
      <form
        className={`upload-drop-zone ${dragActive ? 'active' : ''}`}
        onDragEnter={handleDrag}
        onDragLeave={handleDrag}
        onDragOver={handleDrag}
        onDrop={handleDrop}
        onSubmit={(e) => e.preventDefault()}
      >
        <input
          type="file"
          id="file-upload"
          className="upload-input-hidden"
          onChange={handleChange}
          accept=".pdf,.docx,.txt"
          disabled={uploading}
        />

        {uploading ? (
          <div className="upload-status">
            <div className="upload-spinner"></div>
            <p>Uploading document...</p>
          </div>
        ) : (
          <label htmlFor="file-upload" className="upload-label">
            <div className="upload-icon">
              <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                <polyline points="17 8 12 3 7 8"></polyline>
                <line x1="12" y1="3" x2="12" y2="15"></line>
              </svg>
            </div>
            <p className="upload-text-primary">
              {dragActive ? 'Drop file here' : 'Drag and drop or click to upload'}
            </p>
            <p className="upload-text-secondary">
              Supported formats: PDF, DOCX, TXT (max 50MB)
            </p>
          </label>
        )}
      </form>
    </div>
  );
};

export default DocumentUpload;
